var _excluded = ["id", "dangerouslySetClassNames", "disabled", "isActive", "sizeVariant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/** A modified version of default CK checkbox with added styles
 * 1. when a checkbox is ticked/unticked and hovered over in a menu,
 * 2. no default padding */

import React from "react";
import styled from "styled-components";
import { spacingHelper } from "../../../utils";
var borderHelper = state => _ref => {
  var {
    $isActive,
    theme
  } = _ref;
  var colors = {
    active: theme.palette.borderPrimary,
    standard: theme.palette.borderPrimary,
    checked: theme.palette.borderSelected
  };
  var borderWeights = {
    v3: theme.border.width.thick,
    v4: theme.border.width.thin
  };
  if ($isActive) return borderWeights.v4 + " solid " + (state ? colors[state] : colors.active);else return borderWeights.v4 + " solid " + (state ? colors[state] : colors.standard);
};
var HiddenCheckbox = styled.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "Checkbox__HiddenCheckbox",
  componentId: "sc-c1jea8-0"
})(["width:", ";height:", ";position:absolute;margin:0;opacity:0;cursor:pointer;z-index:1;:disabled{cursor:not-allowed;}"], spacingHelper("medium"), spacingHelper("medium"));
var StyledCheckbox = styled.div.withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-c1jea8-1"
})(["border:", ";border-radius:", ";width:", ";height:", ";display:inline-block;position:absolute;", ":checked ~ &&{background-color:", ";border:", ";}"], borderHelper(), _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.border.radius.small;
}, spacingHelper("medium"), spacingHelper("medium"), HiddenCheckbox, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.palette.backgroundSelected;
}, borderHelper("checked"));
var CheckMark = styled.svg.withConfig({
  displayName: "Checkbox__CheckMark",
  componentId: "sc-c1jea8-2"
})(["width:", ";height:", ";position:absolute;display:none;cursor:pointer;color:", ";", ":checked ~ &&{display:block;}", ":disabled ~ &&{cursor:not-allowed;}"], spacingHelper("medium"), spacingHelper("medium"), _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.palette.textInverted;
}, HiddenCheckbox, HiddenCheckbox);
var CheckBoxContainer = styled.div.withConfig({
  displayName: "Checkbox__CheckBoxContainer",
  componentId: "sc-c1jea8-3"
})(["position:relative;width:", ";height:", ";margin:", ";flex-shrink:0;display:flex;float:left;align-items:center;"], spacingHelper("medium"), _ref5 => {
  var {
    theme,
    $sizeVariant
  } = _ref5;
  return $sizeVariant === "small" ? theme.typography.body02.lineHeight : theme.typography.body01.lineHeight;
}, _ref6 => {
  var {
    theme
  } = _ref6;
  return "0 " + theme.spacing.small + " 0 0";
});
/** An input element that allows users to select one or more options. */
var Checkbox = _ref7 => {
  var {
      id,
      dangerouslySetClassNames,
      disabled,
      isActive,
      sizeVariant
    } = _ref7,
    props = _objectWithoutPropertiesLoose(_ref7, _excluded);
  return /*#__PURE__*/React.createElement(CheckBoxContainer, {
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.checkboxContainer,
    $sizeVariant: sizeVariant
  }, /*#__PURE__*/React.createElement(HiddenCheckbox, _extends({
    id: id,
    disabled: disabled,
    tabIndex: -1
  }, props)), /*#__PURE__*/React.createElement(StyledCheckbox, {
    $isActive: isActive,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.checkbox
  }), /*#__PURE__*/React.createElement(CheckMark, {
    viewBox: "-3 -4 16 16",
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.checkmark
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4.429l2.286 2.285L9 1",
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default Checkbox;